import React from 'react';
import PropTypes from 'prop-types';
import ADGMPanelInputsGeneratorBody from 'aurora-components/ADGMPanelInputsGenerator/ADGMPanelInputsGeneratorBody';
import withStyles from '@material-ui/core/styles/withStyles';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

const UpdateEntity = ({ classes, formData, handleInputChange }) => {
  const isCompany = formData?.userType === 'COMPANY';
  const isUAEResident = formData?.userType === 'UAE_RESIDENT';
  const isNONUAEResident = formData?.userType === 'NON_UAE_RESIDENT';
  const SECTION_FIELDS = [
    {
      title: '',
      fields: [
        ...(isNONUAEResident
          ? [
              {
                label: keyEmptyCheck('Passport_number'),
                required: true,
                type: 'text',
                value: formData?.passportNo,
                disabled: true,
              },
            ]
          : []),
        ...(isUAEResident
          ? [
              {
                label: keyEmptyCheck('eid_moi_num'),
                required: true,
                type: 'text',
                value: formData?.eid,
                disabled: true,
              },
            ]
          : []),
        ...(isUAEResident || isNONUAEResident
          ? [
              {
                label: keyEmptyCheck('Name_English_bracket'),
                required: true,
                type: 'text',
                value: formData?.nameEn,
                disabled: true,
              },
              {
                label: keyEmptyCheck('Name_Arabic_bracket'),
                required: true,
                type: 'text',
                value: formData?.nameAr,
                disabled: true,
              },
              {
                label: keyEmptyCheck('nationality'),
                required: true,
                type: 'text',
                value: formData?.nationality,
                disabled: true,
              },
            ]
          : []),
        ...(isUAEResident
          ? [
              {
                label: keyEmptyCheck('Date_of_birth'),
                required: true,
                type: 'text',
                value: formData?.dob,
                disabled: true,
              },
            ]
          : []),
        ...(isUAEResident || isNONUAEResident
          ? [
              {
                label: keyEmptyCheck('Passport_issue_date'),
                required: true,
                type: 'text',
                value: formData?.passportIssueDate,
                disabled: true,
              },
              {
                label: keyEmptyCheck('Passport_expiry_date'),
                required: true,
                type: 'text',
                value: formData?.passportExpiryDate,
                disabled: true,
              },
            ]
          : []),
        ...(isCompany
          ? [
              {
                label: keyEmptyCheck('Trade_license_number'),
                required: true,
                disabled: true,
                type: 'text',
                value: formData?.tradeLicenseNo,
              },
              {
                label: keyEmptyCheck('company_name_english'),
                required: true,
                disabled: true,
                type: 'text',
                value: formData?.companyNameEn,
              },
              {
                label: keyEmptyCheck('company_name_arabic'),
                required: true,
                disabled: true,
                type: 'text',
                value: formData?.companyNameAr,
              },
            ]
          : []),
        {
          label: keyEmptyCheck('Phone_Number'),
          placeholder: 'Phone_Number',
          type: 'text',
          required: true,
          name: 'phone',
          disabled: !formData?.canEditMobile,
          value: formData?.phone,
          onChange: event => handleInputChange(event.target.name, event.target.value),
        },
        {
          label: keyEmptyCheck('email'),
          placeholder: 'email',
          type: 'text',
          required: true,
          name: 'email',
          disabled: !formData?.canEditEmail,
          value: formData?.email,
          onChange: event => handleInputChange(event.target.name, event.target.value),
        },
      ],
      labels: [
        {
          label: keyEmptyCheck('termination_type'),
          value: keyEmptyCheck('choose_option'),
        },
      ],
    },
  ];
  return (
    <div className={classes.wrapper}>
      <ADGMPanelInputsGeneratorBody
        isEditable
        title=''
        sections={SECTION_FIELDS}
        classes={{
          containerPadding: classes.modalContainerModified,
          sectionTitle: classes.modalSectionTittle,
          titleWrapper: classes.modalTitleWrapper,
        }}
      />
    </div>
  );
};
UpdateEntity.propTypes = {
  classes: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(UpdateEntity);
